<ng-template #googleG>
    <svg class="grw-g" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"></path>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"></path>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"></path>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"></path>
    </svg>
</ng-template>

<section class="grw-outer">
    <div class="grw-wrapper">
        <h2 class="grw-section-header" *ngIf="header">{{ header }}</h2>

        <header class="grw-header" *ngIf="!loading && !error && total > 0">
            <div class="grw-summary">
                <div class="grw-title">
                    <ng-container *ngTemplateOutlet="googleG"></ng-container>
                    <span>Google Reviews</span>
                </div>
                <div class="grw-rating">
                    <strong class="grw-rating-value">{{ averageRating }}</strong>
                    <span class="grw-stars" aria-hidden="true">
                        <span
                            *ngFor="let i of starIndexes"
                            class="grw-star"
                            [class.filled]="i < Math.round(averageRating)">★</span>
                    </span>
                    <span class="grw-count">{{ total }} reviews</span>
                </div>
            </div>
            <a class="grw-write-btn" [href]="writeReviewUrl" target="_blank" rel="noopener noreferrer">
                Write a Review
            </a>
        </header>

        <div class="grw-loading" *ngIf="loading">Loading reviews...</div>
        <div class="grw-loading" *ngIf="error">Reviews are temporarily unavailable.</div>
        <div class="grw-loading" *ngIf="!loading && !error && displayReviews.length === 0">See what our customers say on Google.</div>
        <p class="grw-selection" *ngIf="!loading && !error && displayReviews.length > 0">Recent 4–5 star reviews</p>

        <div class="grw-carousel" *ngIf="!loading && !error && displayReviews.length > 0">
            <button
                type="button"
                class="grw-arrow left"
                (click)="prev()"
                [disabled]="currentPage === 0"
                aria-label="Previous reviews">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>

            <div class="grw-viewport">
                <div class="grw-track" [style.transform]="trackTransform">
                    <a
                        *ngFor="let r of displayReviews"
                        class="grw-card"
                        [style.flex]="'0 0 ' + cardWidth"
                        [href]="r.reviewUrl || reviewsUrl || '#'"
                        target="_blank"
                        rel="noopener noreferrer">
                        <div class="grw-card-head">
                            <ng-container *ngIf="r.profilePhotoUrl; else avatarFallback">
                                <img
                                    class="grw-avatar"
                                    [src]="r.profilePhotoUrl"
                                    referrerpolicy="no-referrer"
                                    loading="lazy"
                                    alt=""
                                    (error)="onAvatarError($event)" />
                                <div class="grw-avatar fallback" style="display: none">{{ initials(r.reviewerName) }}</div>
                            </ng-container>
                            <ng-template #avatarFallback>
                                <div class="grw-avatar fallback">{{ initials(r.reviewerName) }}</div>
                            </ng-template>
                            <div class="grw-card-meta">
                                <div class="grw-name">{{ r.reviewerName || 'Anonymous' }}</div>
                                <div class="grw-sub">
                                    <span class="grw-stars small" aria-hidden="true">
                                        <span
                                            *ngFor="let i of starIndexes"
                                            class="grw-star"
                                            [class.filled]="i < Math.round(r.rating)">★</span>
                                    </span>
                                    <span class="grw-date" *ngIf="r.createdAt">{{ relativeDate(r.createdAt) }}</span>
                                </div>
                            </div>
                        </div>
                        <p class="grw-body" *ngIf="r.text">{{ r.text }}</p>
                        <div class="grw-posted">
                            <ng-container *ngTemplateOutlet="googleG"></ng-container>
                            <span>Posted on Google</span>
                        </div>
                    </a>
                </div>
            </div>

            <button
                type="button"
                class="grw-arrow right"
                (click)="next()"
                [disabled]="currentPage >= pageCount - 1"
                aria-label="Next reviews">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>

        <div class="grw-dots" *ngIf="!loading && !error && pageCount > 1">
            <button
                type="button"
                *ngFor="let p of pages; let i = index"
                class="grw-dot"
                [class.active]="i === currentPage"
                (click)="goTo(i)"
                [attr.aria-label]="'Go to page ' + (i + 1)"></button>
        </div>

        <div class="grw-footer" *ngIf="!loading && reviewsUrl">
            <a [href]="reviewsUrl" target="_blank" rel="noopener noreferrer">View all reviews on Google</a>
        </div>
    </div>
</section>
